import React from "react";
import { Helmet } from "react-helmet";

const HelmetWrapper = ({ no_index, no_follow, theme_color = "#efc343", page, ...rest }) => {
    const helmet = page && page.helmet ? page.helmet : {};
    const title = rest.title || helmet.meta_title || "Resources for Educators and Businesses";
    const lang = rest.lang || helmet.language || "en";
    const description =
        rest.description ||
        helmet.meta_description ||
        "Resources to get you speaking for yourself. This hub of assets contains Infographics, Reports, eBooks, Videos, Webinars, Fact Sheets, and Customer Stories.";
    const image = rest.image || "https://www.rosettastone.com/lp/assets/rs_og_logo.jpg";
    const canonical_url = helmet.canonical_url || rest.canonical_url;
    let robotsTag = null;
    if (no_index && no_follow) {
        robotsTag = <meta name="robots" content="noindex, nofollow" />;
    } else if (no_index) {
        robotsTag = <meta name="robots" content="noindex, follow" />;
    } else if (no_follow) {
        robotsTag = <meta name="robots" content="index, nofollow" />;
    }
    let trustpilot = "";
    if (rest.trustpilot || helmet.trustpilot) {
        trustpilot = (
            <script
                type="text/javascript"
                src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
                async
            />
        );
    }
    return (
        <Helmet defaultTitle="RS Resources">
            <title>{title}</title>
            <link href="https://www.rosettastone.com/lp/home/assets/favicon.ico" rel="shortcut icon" type="image/ico" />
            <meta name="description" content={`${description}`} />
            <meta name="theme-color" content={theme_color} />

            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:type" content="website" />
            <meta property="og:image" content={image} />
            <meta property="og:site_name" content="Rosetta Stone" />

            <meta name="twitter:card" content="summary" />
            <meta name="twitter:image" content={image} />
            <meta name="twitter:site" content="@rosettastone" />
            <meta name="twitter:creator" content="@rosettastone" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            {robotsTag}
            <link rel="canonical" href={canonical_url} />
            <html lang={lang} />
            {trustpilot}
        </Helmet>
    );
};

export default HelmetWrapper;

/* <link rel="preload" href="https://www.rosettastone.com/lp/assets/fonts/helvetica/Helvetica-Bold-02.WOFF" as="font" />
    <link rel="preload" href="https://www.rosettastone.com/lp/assets/fonts/effra/Effra_Std_Rg.woff" as="font" />
    <link rel="preload" href="https://www.rosettastone.com/lp/assets/fonts/effra/Effra_Std_Md.woff" as="font" /> */
